import { render, staticRenderFns } from "./AutoTopUpNotLegislatedModal.vue?vue&type=template&id=0cc243c2&"
import script from "./AutoTopUpNotLegislatedModal.vue?vue&type=script&lang=js&"
export * from "./AutoTopUpNotLegislatedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports